import { createContext, useContext } from "react";

import { IRolloutPackageContext } from "./rollout-package-context.interface";

export const RolloutPackageContext = createContext<IRolloutPackageContext>(
  {} as IRolloutPackageContext
);

export const useRolloutPackage = () =>
  useContext<IRolloutPackageContext>(RolloutPackageContext);
